import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { methodologyService, SystemSettings } from './firebase';

// Default settings
const defaultSettings: SystemSettings = {
  disableLogin: false,
  disableSignup: false,
  disableAI: false,
  disableStraightUpMethodologies: false,
  disableGuidedMethodologies: false,
  disablePathway: false,
  disablePentestOrchestrator: false,
  disableHuntersBoard: false,
  disableHackerChecklists: false,
  disableLOLBAS: false,
  lolbasDescription: '',
  disableGTFOBins: false,
  gtfobinsDescription: '',
  disableWADComs: false,
  wadcomsDescription: '',
  disableReverseShell: false,
  reverseShellDescription: '',
  disableOSINT: false,
  osintDescription: '',
  featuredMethodology: undefined,
  featuredToolkit: undefined
};

interface SystemSettingsContextType {
  settings: SystemSettings;
  loading: boolean;
  refreshSettings: () => Promise<void>;
}

const SystemSettingsContext = createContext<SystemSettingsContextType>({
  settings: defaultSettings,
  loading: true,
  refreshSettings: async () => {}
});

export const useSystemSettings = () => useContext(SystemSettingsContext);

interface SystemSettingsProviderProps {
  children: ReactNode;
}

export const SystemSettingsProvider = ({ children }: SystemSettingsProviderProps) => {
  const [settings, setSettings] = useState<SystemSettings>(defaultSettings);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const fetchedSettings = await methodologyService.getSystemSettings();
      console.log('Fetched system settings:', fetchedSettings);
      setSettings(fetchedSettings);
    } catch (error) {
      console.error('Error fetching system settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SystemSettingsContext.Provider 
      value={{ 
        settings, 
        loading,
        refreshSettings: fetchSettings
      }}
    >
      {children}
    </SystemSettingsContext.Provider>
  );
}; 